"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var category_list_view_model_1 = require("../model/category/category-list-view.model");
var disaggregation_model_1 = require("../model/category/disaggregation.model");
var disaggregation_item_model_1 = require("../model/category/disaggregation-item.model");
var question_model_1 = require("../model/category/question.model");
var answer_model_1 = require("../model/category/answer.model");
var saveResult_model_1 = require("../model/response/saveResult.model");
var validationMessage_model_1 = require("../model/response/validationMessage.model");
var if_structure_view_model_1 = require("../model/if-structure-view.model");
var copy_result_model_1 = require("../model/response/copy-result.model");
var period_parent_model_1 = require("../model/period/period-parent.model");
var data_point_model_1 = require("../model/indicator/data-point.model");
var data_format_model_1 = require("../model/indicator/data-format.model");
var expression_model_1 = require("../model/expression/expression.model");
/**
 * @author by Gor.Hakobyan on 30-Apr-18.
 */
var ConvertUtil = /** @class */ (function () {
    function ConvertUtil() {
    }
    /**
     * convert backed category list view to frontend category list view
     * @returns {CategoryListView[]}
     */
    ConvertUtil.backendCategoryListViewToFrontendCategoryListView = function (response) {
        return response.map(function (value) { return new category_list_view_model_1.CategoryListView(value.id, new idm_crosscutting_concepts_frontend_1.MultilingualString(ConvertUtil.objectToMap(value.name)), value.classifierSystemName); });
    };
    /**
     * convert backed disaggregation to frontend disaggregation
     * @returns {Disaggregation}
     */
    ConvertUtil.backendDisaggregationToFrontendDisaggregation = function (response) {
        return new disaggregation_model_1.Disaggregation(response.id, new idm_crosscutting_concepts_frontend_1.MultilingualString(ConvertUtil.objectToMap(response.name)), response.classifierSystemName, response.classifierId, response.items.map(function (value) { return new disaggregation_item_model_1.DisaggregationItem(value.id, new idm_crosscutting_concepts_frontend_1.MultilingualString(ConvertUtil.objectToMap(value.name)), value.disaggregationId, value.isDna, value.parentId); }));
    };
    /**
     * convert  frontend disaggregation to backed disaggregation
     * @returns {Disaggregation}
     */
    ConvertUtil.frontendDisaggregationToBackendDisaggregation = function (disaggregation) {
        return {
            "id": disaggregation.id,
            "name": ConvertUtil.convertMultilingualStringToMap(disaggregation.name),
            "classifierSystemName": disaggregation.classifierSystemName,
            "classifierId": disaggregation.classifierId,
            "items": disaggregation.items.map(function (disaggregationItem) {
                return {
                    "id": disaggregationItem.id,
                    "name": ConvertUtil.convertMultilingualStringToMap(disaggregationItem.name),
                    "disaggregationId": disaggregationItem.disaggregationId,
                    "isDna": disaggregationItem.isDna
                };
            })
        };
    };
    /**
     * convert  frontend question to backed question
     * @returns {Disaggregation}
     */
    ConvertUtil.frontendQuestionToBackendQuestion = function (question) {
        return {
            "id": question.id,
            "name": ConvertUtil.convertMultilingualStringToMap(question.name),
            "answers": question.answers.map(function (answer) {
                return {
                    "id": answer.id,
                    "name": ConvertUtil.convertMultilingualStringToMap(answer.name),
                    "questionId": answer.questionId,
                    "rank": answer.rank
                };
            })
        };
    };
    /**
     * convert backed Question to frontend Question
     * @returns {Question}
     */
    ConvertUtil.backendQuestionToFrontendQuestion = function (response) {
        return new question_model_1.Question(response.id, new idm_crosscutting_concepts_frontend_1.MultilingualString(ConvertUtil.objectToMap(response.name)), response.answers.map(function (value) { return new answer_model_1.Answer(value.id, new idm_crosscutting_concepts_frontend_1.MultilingualString(ConvertUtil.objectToMap(value.name)), value.questionId, value.rank); }));
    };
    ConvertUtil.backendSaveResultToFrontendSaveResult = function (response) {
        return new saveResult_model_1.SaveResultModel(response.success, response.newId, response.messages ?
            response.messages.map(function (value) { return new validationMessage_model_1.ValidationMessageModel(value.severity, value.relatedFields, value.messageKey); }) : null, response.user ? response.user.name : null, response.date);
    };
    ConvertUtil.backendCopyResultToFrontendCopyResult = function (response) {
        return new copy_result_model_1.CopyResultModel(response.success, response.newId, response.messages ?
            response.messages.map(function (value) { return new validationMessage_model_1.ValidationMessageModel(value.severity, value.relatedFields, value.messageKey); }) : null, response.user ? response.user.name : null, response.date, response.indicator);
    };
    ConvertUtil.convertMultilingualStringToMap = function (value) {
        if (!value) {
            return null;
        }
        var objectMap = {};
        value.toMap().forEach(function (value, key) {
            objectMap[key] = value;
        });
        return objectMap;
    };
    ConvertUtil.objectToMap = function (response) {
        var map = new Map();
        for (var key in response) {
            map.set(parseInt(key), response[key]);
        }
        return map;
    };
    ConvertUtil.ConvertToIFStructureViewArray = function (response) {
        var array = [];
        for (var _i = 0, response_1 = response; _i < response_1.length; _i++) {
            var item = response_1[_i];
            array.push(new if_structure_view_model_1.IFStructureView(item['id'], item['name'], item['systemName'], item['level'], item['instanceIdFieldName'], item['nameFieldKey']));
        }
        return array;
    };
    ConvertUtil.ConvertToValidationMessageModel = function (response) {
        return response.map(function (value) { return new validationMessage_model_1.ValidationMessageModel(value.severity, value.relatedFields, value.messageKey); });
    };
    ConvertUtil.backendPeriodParentToFrontendPeriodParent = function (response) {
        var result = [];
        for (var _i = 0, response_2 = response; _i < response_2.length; _i++) {
            var item = response_2[_i];
            result.push(new period_parent_model_1.PeriodParentModel(item['id'], item['parentId']));
        }
        return result;
    };
    ConvertUtil.backendDataPointToFrontendDataPoint = function (res) {
        var dataFormat = res.dataFormat ? new data_format_model_1.DataFormat(res.dataFormat.type, res.dataFormat.isPercentage, res.dataFormat.numberOfDecimalPlaces, res.dataFormat.isMultiline, res.dataFormat.isComment, res.dataFormat.isMultilingual) : null;
        var expression = res.expression ? new expression_model_1.MeExpressionModel(res.expression.id, res.expression.expression, res.expression.context, res.expression.template, res.expression.type) : null;
        var dataPoint = new data_point_model_1.DataPoint(res.id, new idm_crosscutting_concepts_frontend_1.MultilingualString(ConvertUtil.objectToMap(res.name)), res.skippedInAggregationRules, dataFormat, res.questionId, expression, res.aggregateArea);
        return dataPoint;
    };
    return ConvertUtil;
}());
exports.ConvertUtil = ConvertUtil;
//# sourceMappingURL=category-convert.util.js.map